import {
  AccountDetailForSelector,
  AccountProductEnum,
} from '@varo/graphql-schema-types';

export const getCheckingAccount = (
  accounts: AccountDetailForSelector[],
): AccountDetailForSelector | undefined => {
  return accounts?.find(
    (account) => account?.name === (AccountProductEnum.Checking as string),
  );
};

export const getSavingAccount = (
  accounts: AccountDetailForSelector[],
): AccountDetailForSelector | undefined => {
  return accounts?.find(
    (account) => account?.name === (AccountProductEnum.Savings as string),
  );
};

export const getAvailableBalance = (
  account: AccountDetailForSelector | undefined,
): string | number => {
  if (!account) {
    return '0';
  }

  const balanceItem = account.availableBalance.amount;
  if (balanceItem) {
    return balanceItem;
  }

  return '0';
};
